import { Loader2 } from "lucide-react";
import {
  registerTeamForEvent,
  type PastTeamSummary,
} from "@/api/registrations";
import type { UpcomingEvent } from "@/api/eventDiscovery";
import { Button } from "@/components/ui/button";
import { TeamChooser } from "./TeamChooser";
import { useTeamChoice } from "./useTeamChoice";
import type { OnAction } from "./types";

interface Props {
  event: UpcomingEvent;
  pastTeams: PastTeamSummary[];
  busy: boolean;
  onAction: OnAction;
  onCancel: () => void;
}

export function SwitchToTeamPanel({
  event,
  pastTeams,
  busy,
  onAction,
  onCancel,
}: Props) {
  const { choice, setChoice, canSubmit } = useTeamChoice(pastTeams);

  const submit = async () => {
    if (!canSubmit) return;
    const payload =
      choice.kind === "existing"
        ? { teamId: choice.teamId }
        : { newTeamName: choice.name.trim() };
    await onAction(
      () => registerTeamForEvent(event.event_id, payload),
      "Switched to team",
      "Couldn't switch",
      "Please try again.",
    );
  };

  return (
    <div className="space-y-3">
      <TeamChooser
        pastTeams={pastTeams}
        value={choice}
        onChange={setChoice}
        idPrefix="switch"
      />
      <div className="flex justify-end gap-2">
        <Button variant="ghost" size="sm" onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button size="sm" onClick={submit} disabled={busy || !canSubmit}>
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
          Switch
        </Button>
      </div>
    </div>
  );
}
